import classNames from 'classnames';
import type { IntlShape } from 'react-intl';
import Heading from '@alltrails/denali/components/Heading';
import FacebookIcon from '../../socialIcons/FacebookIcon';
import InstagramIcon from '../../socialIcons/InstagramIcon';
import LinkedInIcon from '../../socialIcons/LinkedInIcon';
import TikTokIcon from '../../socialIcons/TikTokIcon';
import TwitterIcon from '../../socialIcons/TwitterIcon';
import styles from './styles.module.scss';

interface Props {
  intl: IntlShape;
  noFollowSocials?: boolean;
}

const ConnectWithUs = ({ noFollowSocials = true, intl }: Props) => (
  <>
    <Heading as="h2" className={styles.title} size="300">
      {intl.formatMessage({ defaultMessage: 'Connect with us' })}
    </Heading>
    <div className={styles.socialIcons}>
      <InstagramIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <TikTokIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <FacebookIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <TwitterIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <LinkedInIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
    </div>
  </>
);

export default ConnectWithUs;
